import counterReducer from './counterReducer';
import loggedReducer from './isLogged';
import projectManager from './projectManager';
import assignRole from './assignRole';
import storeTeam from './storeTeam';
import setPM from './setPM';
import getQuiz from './getQuiz';
import storeMember from './storeMember';
import searchItem from './searchItem';
import storeQuizzes from './storeQuizzes';
import teamName from './teamName'
import teamSponsor from './teamSponsor';
import storeQuestions from './storeQuestions';
import unassignedStudents from './unassignedStudents';
import storeQuestionForEditing from './storeQuestionForEditing';
import storeMultChoices from './storeMultChoices';
import storeQuizList from './storeQuizList'
import storeQuizId from './storeQuizId'
import storeAllQuestions from './storeAllQuestions'
import storeGroupId from './storeGroupId'
import storeClassId from './storeClassId'
import updateAllGroups from './updateAllGroups'
import storeQuizForEditing from './storeQuizForEditing'
import storeQuestionId from './storeQuestionId'
import getAssignmentsList from './getAssignmentsList'


import { combineReducers } from 'redux';

const allReducers = combineReducers({
    attendanceCounter: counterReducer,
    isLogged: loggedReducer,
    projectManager: projectManager,
    assignRole :assignRole,
    storeTeam: storeTeam,
    setPM: setPM,
    getQuiz: getQuiz,
    searchItem: searchItem,
    storeMember: storeMember,
    storeQuizzes: storeQuizzes,
    teamName: teamName,
    teamSponsor: teamSponsor,
    storeQuestions: storeQuestions,
    unassignedStudents: unassignedStudents,
    storeQuestionForEditing: storeQuestionForEditing,
    storeMultChoices: storeMultChoices,
    storeQuizList: storeQuizList,
    storeQuizId: storeQuizId,
    storeAllQuestions: storeAllQuestions,
    storeGroupId: storeGroupId,
    storeClassId: storeClassId,
    updateAllGroups: updateAllGroups,
    storeQuizForEditing: storeQuizForEditing,
    storeQuestionId: storeQuestionId,
    getAssignmentsList: getAssignmentsList,

    
});
export default allReducers;